<h1>{{ data.title }}</h1>
<div *ngIf="data.description" class="description">{{ data.description }}</div>
<div class="btn-container">
  <button class="btn-disabled" (click)="onCancelClick()">Cancelar</button>
  <button class="btn-primary" (click)="onConfirmClick()">Aceptar</button>
</div>
